import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=2329c978"
import script from "./WelcomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomePage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports